import React from 'react';
import { cn } from '../lib/utils';

const GoldButton = ({ children, variant = 'primary', className, ...props }) => {
  const [ripples, setRipples] = React.useState([]);

  const createRipple = (event) => {
    const button = event.currentTarget;
    const rect = button.getBoundingClientRect();
    const size = Math.max(rect.width, rect.height);
    const x = event.clientX - rect.left - size / 2;
    const y = event.clientY - rect.top - size / 2;

    const newRipple = { x, y, size, id: Date.now() };
    setRipples((prev) => [...prev, newRipple]);

    setTimeout(() => {
      setRipples((prev) => prev.filter((r) => r.id !== newRipple.id));
    }, 600);
  };

  return (
    <button
      className={cn(
        "relative overflow-hidden rounded-full px-8 py-4 font-medium tracking-wide transition-all duration-300 transform hover:scale-105 active:scale-95",
        variant === 'primary' 
          ? "bg-gradient-to-r from-primary via-[#E5C560] to-primary text-background shadow-[0_0_20px_rgba(212,175,55,0.3)] hover:shadow-[0_0_30px_rgba(212,175,55,0.5)]"
          : "bg-transparent border border-primary text-primary hover:bg-primary/10",
        className
      )}
      onClick={(e) => {
        createRipple(e);
        props.onClick && props.onClick(e);
      }}
      {...props}
    >
      <span className="relative z-10">{children}</span>
      {ripples.map((ripple) => (
        <span
          key={ripple.id}
          className="absolute bg-white/30 rounded-full animate-ripple pointer-events-none"
          style={{
            top: ripple.y,
            left: ripple.x,
            width: ripple.size,
            height: ripple.size,
          }}
        />
      ))}
    </button>
  );
};

export default GoldButton;
